import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=1b4ff05c&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b4ff05c')) {
      api.createRecord('1b4ff05c', component.options)
    } else {
      api.reload('1b4ff05c', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=1b4ff05c&", function () {
      api.rerender('1b4ff05c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-287LMbitTW14O/JS/imageCarousel.vue"
export default component.exports